import { c as _c } from "react/compiler-runtime";
import { Image } from '@petsmart-ui/sparky';
import type { LegacyStarsProps } from './types';
export function LegacyStars(t0) {
  const $ = _c(28);
  const {
    href,
    rating,
    totalReviews,
    size,
    starsLength
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== href || $[1] !== rating || $[2] !== size || $[3] !== starsLength || $[4] !== totalReviews) {
    const fillArray = Array.from({
      length: starsLength
    }, _temp);
    const {
      width,
      height
    } = size;
    const getImage = (src, index) => <Image key={`us-${index}`} src={src} alt="ratings star" className="star-svg" loading="lazy" width={width} height={height} />;
    t5 = href;
    t6 = "ratings-reviews-modal-link";
    if ($[12] !== rating) {
      t7 = <div className="stars-rating">{rating}</div>;
      $[12] = rating;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    t3 = "stars-container";
    const t8 = `${totalReviews} store reviews`;
    let t9;
    if ($[14] !== t8) {
      t9 = <div className="total-review-count">{t8}</div>;
      $[14] = t8;
      $[15] = t9;
    } else {
      t9 = $[15];
    }
    t4 = <div className="unrated-stars-container">{fillArray.map(i_0 => getImage("https://images.petsmartassets.com/is/content/PetSmart/unrated-star-blue", i_0))}{t9}</div>;
    t1 = "rated-stars-container";
    t2 = fillArray.map(i_1 => getImage("https://images.petsmartassets.com/is/content/PetSmart/full-star-blue", i_1));
    $[0] = href;
    $[1] = rating;
    $[2] = size;
    $[3] = starsLength;
    $[4] = totalReviews;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  if ($[16] !== t1 || $[17] !== t2) {
    t8 = <div className={t1}>{t2}</div>;
    $[16] = t1;
    $[17] = t2;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t3 || $[20] !== t4 || $[21] !== t8) {
    t9 = <div className={t3}>{t4}{t8}</div>;
    $[19] = t3;
    $[20] = t4;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== t9) {
    t10 = <a href={t5} className={t6}>{t7}{t9}</a>;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
}
function _temp(_, i) {
  return i + 1;
}